import { Box, Spacer, Title } from '@color/continuum';

import { useCrossTabQueryInvalidation } from '../crossTabSync';

import { AutoRefreshSelect, useAutoRefreshState } from './AutoRefreshSwitch';
import { VariantClassificationDataGrid } from './VariantClassificationDataGrid';
import { VariantClassificationForm } from './VariantClassificationForm';
import { VariantClassificationListButtons } from './VariantClassificationListButtons';

export const VariantClassificationListView = () => {
  useCrossTabQueryInvalidation();
  const autoRefreshState = useAutoRefreshState();

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Title>Variant classification</Title>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <VariantClassificationListButtons />
          <AutoRefreshSelect autoRefreshState={autoRefreshState} />
        </Box>
      </Box>
      <VariantClassificationForm />
      <Spacer variant="small" />
      <VariantClassificationDataGrid autoRefreshInterval={autoRefreshState.interval} />
    </>
  );
};
